import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ResearchGridPageComponent } from "./research-grid-page/research-grid-page.component";
import { AntGridCustomModule } from "../ant-grid-custom/ant-grid-custom-module";
import { RouterModule, Routes } from "@angular/router";
import { IconsModule } from "@va/core-library/icons";

import { DateFilterComponent } from "./date-filter/date-filter.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";

// ant modules
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzSwitchModule } from "ng-zorro-antd/switch";

const researchRoutes: Routes = [
  {
    path: ":ticker/:companySymbologyId",
    component: ResearchGridPageComponent,
    data: {
      title: "Company Research Viewer",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(researchRoutes)],
  exports: [RouterModule],
})
export class ResearchRoutingModule {}

@NgModule({
  imports: [
    FormsModule,
    NzDatePickerModule,
    NzRadioModule,
    NzToolTipModule,
    CommonModule,
    AntGridCustomModule,
    ResearchRoutingModule,
    IconsModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NzMenuModule,
    NzSwitchModule,
    NzPopoverModule,
    NzButtonModule,
    NzSpinModule,
    NzDividerModule,
    NzIconModule,
  ],
  declarations: [ResearchGridPageComponent, DateFilterComponent],
  exports: [ResearchGridPageComponent, DateFilterComponent],
})
export class ResearchGridPageModule {}
